import { InjectableClass } from '@fino/lib-injection';
import { AccountIdValidationService } from '../../domain/accountIdValidation.service';
import _ from 'lodash';

const SKIP_ACCOUNT_ID_VALIDATION = false;

export class AccountNumberServiceProvider extends InjectableClass {
  constructor(validationRulesProvider, appCacheProvider) {
    'ngInject';
    super({ validationRulesProvider, appCacheProvider });

    this.activate();
  }

  $get() {
    'ngInject';
    return {};
  }

  activate() {
    this.validationRulesProvider.addRule('accountNumber', (value) => {
      if (SKIP_ACCOUNT_ID_VALIDATION) return true;

      const { features } = this.appCacheProvider.get('config');
      const { rules, ranges } = features.accountNumberValidation;

      const rulesValid = !_.isEmpty(rules)
        ? AccountIdValidationService.fullfillsPattern(value, rules)
        : true;

      const rangesValid = !_.isEmpty(ranges)
        ? AccountIdValidationService.fullfillsRanges(value, ranges)
        : true;

      return rulesValid && rangesValid;
    });

    this.validationRulesProvider.addRule('accountNumberBlocked', (value) => {
      const { features } = this.appCacheProvider.get('config');
      const { rulesBlocked } = features.accountNumberValidation;

      return !_.isEmpty(rulesBlocked)
        ? !AccountIdValidationService.fullfillsPattern(value, rulesBlocked)
        : true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/ui/account-number/accountNumber.service.provider.js